import { render } from "./PaymentPaypal.vue?vue&type=template&id=db3ef64c&scoped=true"
import script from "./PaymentPaypal.vue?vue&type=script&lang=js"
export * from "./PaymentPaypal.vue?vue&type=script&lang=js"

import "./PaymentPaypal.vue?vue&type=style&index=0&id=db3ef64c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db3ef64c"]])

export default __exports__